import { lightTheme } from '@/customTheme'
import { StatefulTooltip, PLACEMENT } from 'baseui/tooltip'
import { useTranslation } from 'react-i18next'

function Tooltip(props: {
  info: {
    content: string | React.ReactNode
    placement?: PLACEMENT[keyof PLACEMENT]
    styleOverrides?: {
      Inner?: { style: Record<string, string | number> }
      Body?: { style: Record<string, string | number> }
      Arrow?: { style: Record<string, string | number> }
    }
  },
  ignoreBoundary?: boolean,
  children?: JSX.Element
}) {
  const { t } = useTranslation()
  if (props.info && props.info.content) {
    return (
      <StatefulTooltip
        onMouseEnterDelay={100}
        onMouseLeaveDelay={100}
        accessibilityType={'tooltip'}
        content={() => {
          if(typeof props.info.content === 'string') {
            return <>{t(props.info.content)}</>
          }
          return <>{props.info.content}</>
        }}
        showArrow
        placement={props.info.placement ? props.info.placement : 'auto'}
        popoverMargin={4}
        overrides={{
          Inner: {
            style: ({ $theme }) => ({
              fontFamily: $theme.typography.font400.fontFamily,
              fontSize: '12px',
              fontWeight: 400,
              backgroundColor: lightTheme.colors.blackGray,
              padding: '8px',
              ...props.info.styleOverrides?.Inner?.style
            }),
          },
          Body: {
            style: ({ $theme }) => ({
              zIndex: 1100,
              backgroundColor: lightTheme.colors.blackGray,
              ...props.info.styleOverrides?.Body?.style,
              pointerEvents: 'none'
            }),
          },
          Arrow: {
            style: ({ $theme }) => ({
              zIndex: 1100,
              backgroundColor: lightTheme.colors.blackGray,
              ...props.info.styleOverrides?.Arrow?.style
            }),
          },
        }}
        triggerType='hover'
        ignoreBoundary={props.ignoreBoundary}
      >
        {props.children}
      </StatefulTooltip>
    )
  }
  return props.children
}

export default Tooltip
